module.exports = __webpack_public_path__ + "static/media/bootcamper profile.e2c564b6.png";